<template>
    <vvo v-slot="v" :key="parentFacilityIdx + facilityIdx" class="facility-popup-vvo">
        <!-- 헤더 -->
        <div class="row form-group">
            <div class="col detail-title">
                <!-- <span class="title">{{ newFacility.facilityName }}</span> -->
                <span class="title">{{ hierarchy }}</span>
                <!-- <span class="badge title"> {{ newFacility.facilityAlias }} </span> -->
                <span class="badge title"> {{ facilityIdx }} </span>
                <span v-if="newCT" class="badge id"> CT : {{ newCT }} </span>
                <!-- <span class="badge option"> {{ measTypeCode }} </span> -->
            </div>
        </div>
        <!-- tab area -->
        <div class="tab-container" v-if="!isEmpty(facilityIdx)">
            <!-- tab button -->
            <ul v-if="type === 'facility'" class="custom-tabs">
                <li
                    v-for="(tab, index) in tabs"
                    :key="index"
                    class="custom-tab"
                    :class="{ active: activeTab === index }"
                    @click="handleTabClick(index)"
                >
                    <span class="mr-1"><app-icon :icon="tab.icon" /></span>
                    <span>{{ tab.label }}</span>
                </li>
            </ul>

            <!-- tab content -->
            <div class="tab-content-container mb-0">
                <!-- 수집 항목 설정 탭 -->
                <div v-if="activeTab === 0" :key="'tab-0'" class="load-management-content">
                    <PointMapping :facilityIdx="facilityIdx" :facility="newFacility" :hierarchy="hierarchy" />
                </div>
                <!-- 계측기 설정 탭 -->
                <div v-else-if="activeTab === 1" :key="'tab-1'" class="facility-info-content" style="padding: 10px">
                    <FacilityPopupBody
                        :newFacility="newFacility"
                        :parentFacility="parentFacility"
                        :facilityIdx="facilityIdx"
                        :parentFacilityIdx="parentFacilityIdx"
                        :drivers="drivers"
                        :driverTypes="driverTypes"
                        :getVersion="getVersion"
                        :rules="rules"
                        :validMessage="validMessage"
                        :classes="classes"
                        :isUpdate="isUpdate"
                        :meterTypeCode="meterTypeCode"
                        :measTypeCode="measTypeCode"
                        :newCT="newCT"
                        :aliasSynced="aliasSynced"
                        @input-facility-alias="inputFacilityAlias()"
                        @set-pulse-unit="setPulseUnit()"
                    />

                    <!-- 계측기 정보 추가 끝 -->
                    <div v-if="activeTab === 1" slot="modal-footer" class="w-100 mt-3">
                        <!-- GS 테스트를 위한 임시 작업, 20250617  -->
                        <!-- v-xe-pm.E 삭제 -->
                        <button class="btn btn-danger" v-if="isUpdate" @click="onDeleteFacility()">
                            <i class="fa fa-times"></i> {{ $t("삭제") }}
                        </button>
                        <button class="btn btn-primary pull-right" @click="onValidate(v, onSaveFacility, newFacility)">
                            <i class="fa fa-save"></i> {{ $t("저장") }}
                        </button>
                    </div>
                </div>
                <div v-else-if="activeTab === 2" :key="'tab-2'" class="load-management-content">
                    <!-- 헤더 매핑 섹션과 오류 목록 섹션 -->
                    <FacilityListManagement :newFacility="newFacility" @upload-success="handleUploadSuccess" />
                </div>
                <div v-else-if="activeTab === 3" :key="'tab-3'" class="load-management-content">
                    <FacilityDataDownload
                        :facilityIdx="facilityIdx"
                        :subFacilityList="parentData.children"
                        :getPurpsUseCode="getPurpsUseCode"
                    />
                </div>
                <div v-else-if="activeTab === 4" :key="'tab-4'" class="load-management-content">
                    <FacilityManagementInfo
                        :facilityIdx="facilityIdx"
                        @metadata-saved="handleMetadataSaved"
                        @images-saved="handleImagesSaved"
                    />
                </div>
            </div>
        </div>

        <FacilityPopupBody
            v-else
            :newFacility="newFacility"
            :parentFacility="parentFacility"
            :facilityIdx="facilityIdx"
            :parentFacilityIdx="parentFacilityIdx"
            :drivers="drivers"
            :driverTypes="driverTypes"
            :getVersion="getVersion"
            :rules="rules"
            :validMessage="validMessage"
            :classes="classes"
            :isUpdate="isUpdate"
            :meterTypeCode="meterTypeCode"
            :measTypeCode="measTypeCode"
            :newCT="newCT"
            :aliasSynced="aliasSynced"
            mode="panel"
            @input-facility-alias="inputFacilityAlias()"
            @set-pulse-unit="setPulseUnit()"
        />

        <!-- 계측기 정보 추가 끝 -->
        <div v-if="mode != 'panel'" slot="modal-footer" class="w-100 mt-3">
            <!-- GS 테스트를 위한 임시 작업, 20250617  -->
            <!-- v-xe-pm.E 삭제 -->
            <button class="btn btn-danger" v-if="isUpdate" @click="onDeleteFacility()">
                <i class="fa fa-times"></i> {{ $t("삭제") }}
            </button>
            <button class="btn btn-primary pull-right" @click="onValidate(v, onSaveFacility, newFacility)">
                <i class="fa fa-save"></i> {{ $t("저장") }}
            </button>
        </div>
    </vvo>
</template>

<script>
import backEndApi from "@api/backEndApi.js";
import * as rules from "@src/consts/ruleConsts.js";
import * as validMessage from "@src/consts/validMessageConsts";
import * as popupMessages from "@src/consts/popupMessageConsts";
import * as controlMessages from "@src/consts/controlMessageConsts";
import FacilityPopupBody from "./FacilityPopupBody.vue";
import FacilityDataDownload from "./FacilityDataDownload.vue";
import PointMapping from "./PointMapping.vue";
import FacilityListManagement from "./FacilityListManagement.vue";
import FacilityManagementInfo from "./FacilityManagementInfo.vue";
import { mapGetters } from "vuex";

export default {
    components: {
        FacilityPopupBody,
        FacilityDataDownload,
        PointMapping,
        FacilityListManagement,
        FacilityManagementInfo,
    },
    props: {
        parentFacilityIdx: {
            type: [String, Number],
            default: null,
        },
        facilityIdx: {
            type: [String, Number],
            default: null,
        },
        channelType: {
            type: String,
            default: "",
        },

        "save-done": {
            type: Function,
            default: null,
        },
        subFacilityList: {
            type: Array,
            default: () => [],
        },
        newCT: {
            type: [String, Number],
            default: null,
        },
        type: {
            type: String,
            default: "",
        },

        hierarchy: {
            type: String,
            default: "",
        },
        parentData: {
            type: Object,
            default: () => ({}),
        },
        mode: {
            type: String,
            default: "",
        },
        serverIdx: {
            type: Number,
            default: null,
        },
        channelIdx: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            classes: "", // 오류..
            parentFacility: {},
            newFacility: {},
            orgFacility: {},
            aliasSynced: true,
            //driverList: [],
            drivers: [],
            rules,
            validMessage,
            popupMessages,
            controlMessages,
            panel: "panel", // panel 모드 추가

            facilityOption: {
                pulseUnit: null,
            },

            // 서브 모듈 업로드 엑셀파일
            pointUploadXlsx: null,

            /* 탭 상태 */
            activeTab: this.type === "subFacility" ? 3 : 0,

            /* 탭 정의 */
            tabs: [
                {
                    label: "수집 항목 설정",
                    icon: "fa fa-link",
                },
                {
                    label: "계측기 설정",
                    icon: "fa fa-info-circle",
                },
                {
                    label: "부하 목록 관리",
                    icon: "fa fa-upload",
                },
                {
                    label: "수집 데이터 관리",
                    icon: "fa fa-download",
                },
                {
                    label: "계측기 관리정보",
                    icon: "fa fa-cogs",
                },
            ],
            showDescList: ["Code", "Zone"],
            activeDropdownIndex: null,
            isMappingVisible: false,
        };
    },
    computed: {
        ...mapGetters(["commonCodes", "zoneInfo"]),
        getPurpsUseCode() {
            const purpsUseCode = this.newFacility?.purpsUseCode;
            if (!purpsUseCode) return null;
            return `${purpsUseCode.toUpperCase()}LOG`;
        },

        hasExistingMapping() {
            return (
                this.newFacility.fieldMapping ||
                (this.newFacility.extraFields && this.newFacility.extraFields.length > 0)
            );
        },
        isUpdate() {
            return !this.isEmpty(this.facilityIdx);
        },
        driverTypes() {
            // version이 여러개면, driverType이 중복되므로 distinct 해준다.
            return this.drivers.map((v) => v.driverType).unique();
        },
        getVersion() {
            return this.drivers.filter((driver) => driver.driverType == this.newFacility.driverType);
        },
        meterTypeCode() {
            try {
                const result = this.commonCodes.meterTypeCode.find(
                    (item) => item.value == this.newFacility.meterTypeCode
                );
                return result.text ?? "-";
            } catch (err) {
                return "-";
            }
        },
        measTypeCode() {
            try {
                const result = this.commonCodes.measTypeCode.find(
                    (item) => item.value == this.newFacility.measTypeCode
                );
                return result.text ?? "-";
            } catch (err) {
                return "-";
            }
        },
    },
    watch: {
        facilityIdx: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.initSetting();
                }
            },
            immediate: true,
        },

        "newFacility.facilityName": function(newVal) {
            if (this.aliasSynced) this.newFacility.facilityAlias = newVal;
        },
        type: function(newVal) {
            this.activeTab = newVal === "subFacility" ? 3 : 0;
        },
        hasExistingMapping: function(newVal) {
            if (newVal) {
                this.isMappingVisible = true;
                // this.activeTab = 1;
            }
        },
        parentData: {
            handler(newVal, oldVal) {
                // parentData가 바뀌면 탭 상태만 업데이트
                if (newVal !== oldVal && this.activeTab === 1) {
                    // 엑셀 데이터는 FacilityListManagement에서 자체 관리
                }
            },
            deep: true,
        },
    },
    created() {},
    async mounted() {
        await this.initSetting();
    },
    methods: {
        showSubDesc(value) {
            return this.showDescList.includes(this.convertHeaderOptions.find((v) => v.value === value)?.Desc);
        },
        getSubDescList(value, desc) {
            if (desc == "Code") {
                return this.commonCodes[value];
            } else if (desc == "Zone") {
                return this.zoneInfo;
            }
            return [];
        },
        getSubDescListItems(convertHeader) {
            const option = this.convertHeaderOptions.find((v) => v.value === convertHeader);
            if (!option || !option.Desc) return [];

            const desc = option.Desc;
            const list = this.getSubDescList(convertHeader, desc);

            if (Array.isArray(list)) {
                return list;
            } else if (list && list.options) {
                return list.options;
            }
            return [];
        },
        showDropdown(index) {
            this.activeDropdownIndex = index;
        },
        hideDropdown() {
            this.activeDropdownIndex = null;
        },

        initExcelData() {
            this.headerMappings = [];
            this.excelUploadErrorList = [];
            this.isMappingVisible = false;

            this.fileName = "";
            // 파일은 유지 (this.pointUploadXlsx = null 제거)
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = "";
            }
        },
        findHeaderTextFromCommonCodes(value) {
            const header = this.commonCodes.headerMapping.find((header) => header.text === value);
            return header ? header.value : null;
        },

        selectFile() {
            // 파일 선택 시 오류 리스트 초기화
            // this.initExcelData();
            // this.excelUploadErrorList = [];
            // this.$refs.fileInput.click();
        },

        setPulseUnit() {
            // this.newFacility.facilityOption = this.facilityOption;
        },
        driversClear() {
            this.drivers.clear();
        },
        inputFacilityAlias() {
            this.aliasSynced = false;
        },
        initSetting() {
            this.newFacility = {
                serverIdx: this.serverIdx,
                channelIdx: this.channelIdx,
                parentFacilityIdx: this.parentFacilityIdx,
                facilityOption: {},
                driverType: "",
                deviceId: "",
                mappingKey: "",
                facilityName: "",
                applyZoneIdx: null,
                energySourceCode: null,
                energySplyTypeCode: null,
                isUse: true,
                instDate: new Date().toISOString().slice(0, 10),
                clbrPeriodCode: "A006",
                purpsUseCode: null,
            };

            // Pulse형 계측기는 pulseUnit을 관리해야 함.
            if (this.parentFacility.measTypeCode == "Pulse") {
                this.newFacility.facilityOption.pulseUnit = null;
            }

            this.drivers.clear();

            // 장비 드라이버 먼저 조회
            backEndApi.driver.searchDriver().then(({ data }) => {
                if (this.$err(data)) return;
                if (this.isEmpty(this.channelType)) return;
                this.drivers.range(data.filter((v) => v.channelType == this.channelType));

                this.drivers.unshift({
                    channelType: "",
                    driverName: "",
                    driverType: "",
                    remark: "",
                    version: "",
                });

                if (this.drivers.length == 0) {
                    this.alertNoti(popupMessages.POINT_DATA_COLLECTION_INIT_ERROR_POPUP_MESSAGE);
                    return;
                }

                // 장비 상세 정보 조회
                if (this.isUpdate) {
                    backEndApi.facility.getFacility(this.facilityIdx).then(({ data }) => {
                        if (this.$err(data)) return;

                        this.newFacility = data;
                        // this.newFacility.facilityOption = {};
                        try {
                            if (typeof data.facilityOption === "string")
                                this.newFacility.facilityOption = JSON.parse(data.facilityOption);
                        } catch (err) {
                            console.error("Invalid Json Format", err);
                        }
                        // this.facilityOption = this.newFacility.facilityOption;

                        this.newFacility.applyZoneIdx = data.applyZoneIdx;
                        this.newFacility.energySourceCode = data.energySourceCode;
                        this.newFacility.energySplyTypeCode = data.energySplyTypeCode;

                        this.orgFacility = Object.freeze(data);

                        this.aliasSynced = this.newFacility.facilityName == this.newFacility.facilityAlias;

                        this.bindParentDirver();
                    });
                } else {
                    this.bindParentDirver();
                }
            });

            if (this.newCT) {
                this.newFacility.ct = this.newCT;
            }
        },
        bindParentDirver() {
            // 하위 장비 등록시 부모정보 조회
            if (this.parentFacilityIdx) {
                backEndApi.facility.getFacility(this.parentFacilityIdx).then(({ data }) => {
                    // 하위장비 추가인경우, 부모 드라이버 정보를 변경할 수 없다...
                    // TODO: 시간차 오류가 있을 수 있음..
                    if (this.$err(data)) return;
                    this.parentFacility = data;
                    this.newFacility.driverType = data.driverType;
                    this.newFacility.version = data.version;
                    this.newFacility.deviceId = data.deviceId;
                });
            }
        },
        onSaveFacility() {
            if (this.isEmpty(this.newFacility.driverType) || this.isEmpty(this.newFacility.version)) {
                this.alertNoti(popupMessages.POINT_DATA_COLLECTION_ADD_DRIVER_VALID_POPUP_MESSAGE);
                return;
            }

            const regex = /^[A-Za-z0-9\-._]+$/;

            if (this.newCT === undefined) {
                if (!regex.test(this.newFacility.facilityName?.toUpperCase())) {
                    this.alertNoti(popupMessages.POINT_DATA_COLLECTION_ADD_ID_VALID_POPUP_MESSAGE);
                    return;
                }

                if (this.isEmpty(this.newFacility.facilityAlias)) {
                    this.alertNoti(popupMessages.POINT_DATA_COLLECTION_ADD_NAME_VALID_POPUP_MESSAGE);
                    return;
                }
            }

            this.isUpdate ? this.updateFacility() : this.insertFacility();
        },
        insertFacility() {
            if (typeof this.newFacility.facilityOption !== "string")
                this.newFacility.facilityOption = JSON.stringify(this.newFacility.facilityOption);

            // TODO: 하위장비 등록시 다른 ct 번호와 중복되는지 확인해야 함.
            // 이미 존재하는 ct는 입력 할 수 없어야 함.
            this.alertQuestion(popupMessages.COMMON_SAVE_CONFIRM_POPUP_MESSAGE).then((result) => {
                if (!result.value) return;
                backEndApi.facility.insertFacility(this.newFacility).then(({ data, status }) => {
                    // if (this.$err(data)) return;

                    if (status !== 200) {
                        this.alertWarning(data.message);
                        return;
                    }

                    this.newFacility = {};
                    this.alertNoti(popupMessages.COMMON_SAVE_POPUP_MESSAGE);
                    this.$emit("save-done");
                });
            });
        },

        updateFacility() {
            // TODO: 하위장비 변경시 ct가 변경되면, 다른 ct 번호와 중복되는지 확인해야 함.
            // 이미 존재하는 ct는 입력 할 수 없어야 함.
            // TODO: 장비의 드라이버가 변경되면, 하위장비의 드라이버 정보도 전부 변경되어야 한다.
            // 유효성 검사
            if (!this.validateFacilityUpdate()) return;

            // 매핑 정보 업데이트
            this.updateFacilityMapping();

            // 확인 후 업데이트 실행
            this.alertQuestion(popupMessages.COMMON_UPDATE_CONFIRM_POPUP_MESSAGE).then(async (result) => {
                if (!result.value) return;
                await this.executeFacilityUpdate();
            });
        },

        // 유효성 검사 함수
        validateFacilityUpdate() {
            // 드라이버 변경 검사
            if (this.hasDriverChanged()) {
                this.alertNoti(popupMessages.POINT_DATA_COLLECTION_DRIVER_UPDATE_ERROR_POPUP_MESSAGE);
                return false;
            }

            // 계측기명 변경 검사
            if (this.hasFacilityNameChanged()) {
                this.alertNoti(popupMessages.POINT_DATA_COLLECTION_PTADDR_CHANGE_POPUP_MESSAGE);
            }

            return true;
        },

        // 드라이버 변경 여부 확인
        hasDriverChanged() {
            return (
                this.newFacility.driverType !== this.orgFacility.driverType ||
                this.newFacility.version !== this.orgFacility.version
            );
        },

        // 계측기명 변경 여부 확인
        hasFacilityNameChanged() {
            return this.newFacility.facilityName !== this.orgFacility.facilityName;
        },

        // 실제 업데이트 실행
        async executeFacilityUpdate() {
            try {
                // facilityOption 문자열 변환
                this.prepareFacilityOption();

                // 계측기 업데이트
                const updateResult = await this.updateFacilityData();
                if (!updateResult.success) return;

                // 성공 처리
                this.handleUpdateSuccess();
            } catch (error) {
                this.handleUpdateError(error);
            }
        },

        // facilityOption 준비
        prepareFacilityOption() {
            if (typeof this.newFacility.facilityOption !== "string") {
                this.newFacility.facilityOption = JSON.stringify(this.newFacility.facilityOption);
            }
        },

        // 계측기 데이터 업데이트
        async updateFacilityData() {
            const { status, data } = await backEndApi.facility.updateFacility(this.newFacility);

            if (status !== 200) {
                throw new Error(data.message);
            }

            if (this.$err(data)) {
                return { success: false };
            }

            return { success: true, data };
        },

        // 성공 처리
        handleUpdateSuccess() {
            this.alertNoti(popupMessages.COMMON_UPDATE_POPUP_MESSAGE);
            this.$emit("save-done");
            // 성공 후 다시 데이터 fetch
            this.initSetting();
        },

        // 에러 처리
        handleUpdateError(error) {
            console.error("Error updating facility:", error);
            this.alertWarning(error);
            // this.alertNoti(popupMessages.POINT_DATA_COLLECTION_DRIVER_UPDATE_ERROR_POPUP_MESSAGE);
        },
        updateFacilityMapping() {
            if (!this.headerMappings || this.headerMappings.length === 0) return;

            let notSaveList = this.headerMappings.filter((header) => header.convertHeader != "archive");
            let saveList = this.headerMappings.filter((header) => header.convertHeader == "archive");

            // fieldMapping이 null이면 빈 객체로 초기화
            if (!this.newFacility.fieldMapping) {
                this.newFacility.fieldMapping = {};
            }

            this.newFacility.fieldMapping = Object.fromEntries(
                notSaveList.map((header) => [header.excelHeader, header.convertHeader])
            );
            this.newFacility.extraFields = saveList.map((header) => header.excelHeader);
        },

        // 엑셀 업로드 유효성 검사
        validateExcelUpload() {
            if (!this.facilityIdx) {
                console.warn("facilityIdx is missing");
                return false;
            }

            if (!this.pointUploadXlsx) {
                console.warn("pointUploadXlsx is missing");
                return false;
            }

            return true;
        },

        // 엑셀 업로드 실행
        async executeExcelUpload() {
            try {
                const result = await backEndApi.facility.uploadPointInfoByFacility(
                    this.facilityIdx,
                    this.pointUploadXlsx
                );

                if (result.status !== 200) {
                    if (result.data.detail?.errors?.length > 0) {
                        this.excelUploadErrorList = result.data.detail.errors;
                    }
                    throw new Error(result.data.message);
                } else if (result.status === 200) {
                    this.alertNoti(popupMessages.COMMON_SAVE_POPUP_MESSAGE);
                    this.$emit("save-done");
                }
                return result;
            } catch (error) {
                this.handleExcelUploadError(error);
            }
        },

        // 엑셀 업로드 에러 처리
        handleExcelUploadError(error) {
            console.error("Error uploading points from Excel:", error);
            // this.initExcelData();
            this.alertWarning(error);
            return { success: false, error };
        },

        // FacilityListManagement에서 업로드 성공 시 호출되는 메서드
        handleUploadSuccess() {
            this.$emit("save-done");
        },

        // FacilityManagementInfo에서 메타데이터 저장 시 호출되는 메서드
        handleMetadataSaved(metadata) {
            console.log("메타데이터 저장됨:", metadata);
            // 여기에 실제 저장 로직 구현
            this.$emit("save-done");
        },

        // FacilityManagementInfo에서 이미지 저장 시 호출되는 메서드
        handleImagesSaved(images) {
            console.log("이미지 저장됨:", images);
            // 여기에 실제 저장 로직 구현
            this.$emit("save-done");
        },

        onDeleteFacility() {
            // TODO: 하위 정보가 있으면 삭제할 수 없습니다.
            // TOOD: childrens 인자로 받지 않고, 서버에서 조회해야 정확함..

            this.alertConfirmWarning(popupMessages.COMMON_DELETE_CONFIRM_POPUP_MESSAGE).then((result) => {
                if (!result.value) return;

                backEndApi.facility.deleteFacility(this.newFacility.facilityIdx).then(({ data }) => {
                    if (this.$err(data)) return;
                    this.newFacility = {};
                    this.alertNoti(popupMessages.COMMON_DELETE_POPUP_MESSAGE);
                    this.$emit("save-done");
                });
            });
        },

        loadOptions({ callback }) {
            callback();
        },
        /* 탭 수동 클릭 */
        handleTabClick(idx) {
            if (this.activeTab === idx) return;
            this.activeTab = idx;
        },

        /* 파일 업로드 */
        uploadFile() {
            if (!this.pointUploadXlsx) {
                this.alertNoti("업로드할 파일을 먼저 선택해주세요.");
                return;
            }
            // this.excelUploadErrorList = [];

            // executeExcelUpload 메서드 실행
            this.executeExcelUpload();
        },
    },
};
</script>

<style scoped>
.facility-popup-vvo {
    display: block;
    height: 100%;
}
.facility-info-content {
    box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;
    border-radius: 8px;
    padding: 25px !important;
    margin-top: 20px;
    margin-bottom: 30px;
    width: 90%;
}

.detail-title {
    padding: 0 !important;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 1rem;
    font-weight: 600;
}

.title {
    font-size: 14px;
    font-weight: 600;
    margin-left: 10px;
    margin-right: 10px;
}

.badge {
    font-size: 12px;
    font-weight: 500;
    margin-right: 4px;
    display: inline-block;
    min-width: 20px;
    padding: 0px 10px 0px 10px;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
    line-height: 22px;
    border-radius: 8px;
}

.badge.title {
    background-color: #ff6d00;
    color: #fff;
}

.badge.id {
    background-color: #546e7a;
    color: #fff;
}

/* tabs */
.custom-tabs {
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
    background: #fff;
}

.custom-tab {
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-size: 0.8rem;
    font-weight: 600;
    background: transparent;
    color: #6c757d;
    border: none;
    border-bottom: 2px solid transparent;
    transition: all 0.2s ease;
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    min-width: 120px;
    justify-content: center;
}

.custom-tab:hover {
    color: #495057;
    background: #f8f9fa;
    font-weight: 600;
}

.custom-tab.active {
    font-weight: 600;
    border-bottom-color: #007bff;
}

/* tab container */
.tab-container {
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 8px;
    height: 90%;
}

.tab-content-container {
    overflow: auto;
    overflow-x: hidden;
    background: #fff;
    position: relative;
    padding: 12px 12px 0 12px;
    border-top: 1px solid #f1f3f4;
    display: flex;
    justify-content: center;
}

/* 부하 목록 관리 콘텐츠 */
.load-management-content {
    padding: 0;
    width: 100%;
}
</style>
